import { z } from 'zod/v4';
import { PlatformFeatureSchema } from '../schemas/platform-feature.js';

export const ListPlatformFeaturesContract = {
  method: 'GET',
  path: '/admin/platform-features',
  response: z.array(PlatformFeatureSchema),
} as const;
